import React, { Component } from 'react';
import styled from 'styled-components';
import StyledButton from '@stelecom/ui-react/components/buttons/styledButton';
import RadioGroup from '@stelecom/ui-react/components/controls/radioGroup';
import Tabs from '@stelecom/ui-react/components/tabs/tabs';
import Tab from '@stelecom/ui-react/components/tabs/tab';

const EMAIL_TAB_LABEL = 'По e-mail';
const SMS_TAB_LABEL = 'По SMS';

const Text = styled.p`
    margin-bottom: 20px;
    width: 100%;
    @media(max-width: 640px) {
        margin-bottom: 10px;
    }
`;

const Wrapper = styled.div`
    margin-bottom: 30px;
    width: 100%;
`;

class ChooseChannel extends Component {
    static defaultProps = {
        options: {
            phones: [],
            emails: []
        }
    }

    constructor(props) {
        super(props);
        const phones = props.options.phones;
        const emails = props.options.emails;
        const showPhones = phones.length > 0;
        const showEmails = emails.length > 0;
        this.state = {
            showPhones: showPhones,
            selectedPhone: showPhones ? phones[0].value : null,
            showEmails: showEmails,
            selectedEmail: showEmails ? emails[0].value : null,
            activeTab: showPhones ? SMS_TAB_LABEL : EMAIL_TAB_LABEL
        };
    }

    switchTabs = (currentTab) => {
        this.setState({
            activeTab: currentTab
        });
    }

    selectPhone = value => this.setState({ selectedPhone: value })
    selectEmail = value => this.setState({ selectedEmail: value })

    onClickHandler = () => {
        const { next, options } = this.props;
        const { activeTab, selectedEmail, selectedPhone } = this.state;
        if (activeTab === EMAIL_TAB_LABEL) {
            next('email', options.emails.find(item => item.value == selectedEmail));
        } else {
            next('phone', options.phones.find(item => item.value == selectedPhone));
        }
    }

    render() {
        const { activeTab, showPhones, showEmails, selectedPhone, selectedEmail } = this.state;
        const { options } = this.props;
        const phonesList = <RadioGroup name='phone' options={options.phones} selectedValue={selectedPhone} onChange={this.selectPhone}></RadioGroup>;
        const emailList = <RadioGroup name='email' options={options.emails} selectedValue={selectedEmail} onChange={this.selectEmail}></RadioGroup>;

        const text = `Выберите ${showPhones ? 'номер телефона' : ''} ${showPhones && showEmails ? 'или' : ''} ${showEmails ? 'e-mail' : ''} для отправки пароля`;

        return (
            <React.Fragment>
                <Text>{text}</Text>
                {
                    showEmails && showPhones ? <Tabs activeTab={activeTab} onSwitchTab={this.switchTabs}>
                        <Tab label={SMS_TAB_LABEL} key='phoneTab'>
                            {phonesList}
                        </Tab>
                        <Tab label={EMAIL_TAB_LABEL} key='emailTab'>
                            {emailList}
                        </Tab>
                    </Tabs> : <Wrapper>{showPhones && phonesList || showEmails && emailList}</Wrapper>
                }
                <StyledButton text='Далее' onClick={this.onClickHandler} />
            </React.Fragment>
        );
    }
}

export default ChooseChannel;
